export type CsrfFetch = (
  input: RequestInfo | URL,
  init?: RequestInit
) => Promise<Response>;

export function getCsrfToken(): string {
  return document.querySelector<HTMLInputElement>('input[name="csrftoken"]')?.value ?? '';
}

export function makeCsrfFetch(csrfToken: string): CsrfFetch {
  return (input, init = {}) => {
    const headers = new Headers(init.headers);
    headers.set('X-CSRFToken', csrfToken);

    return fetch(input, {
      ...init,
      headers,
    });
  };
}

export async function safeCsrfFetch(csrfFetch: CsrfFetch, ...args: Parameters<CsrfFetch>): Promise<Response> {
    try {
        return await csrfFetch(...args);
    } catch {
        return new Response(null, { status: 500 });
    }
}